// extracted by mini-css-extract-plugin
export default {"root":"IconLink_root__w-6Sc"};